import { createRoot } from "react-dom/client";

import { StrictMode } from "react";

import { initHorizontalDragScroll } from "@shared/utils";

import "@i18n/config";
import "./index.css";
import App from "./App";

const prepare = async () => {
  if (import.meta.env.VITE_MSW_ENABLED === "true") {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "warn" });
  }
};

prepare().then(() => {
  initHorizontalDragScroll();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
